<template>
  <div>
    <div></div>
    <!-- Assignment Multi Update Modal Start -->
    <b-button
      style="font-size: 0.675rem"
      class="mt-2"
      size="sm"
      @click="lock_is_misc_locked =='1' &&(lock_finalBillingCompleted==1 || lock_locked_counter>0)?CommonLockUnLock(lock_item,'locked'):'' "
      :variant="lock_is_misc_locked =='1' &&(lock_finalBillingCompleted==1 || lock_locked_counter>0) ?'danger':'success'"
    >
      <b
        v-if="lock_is_misc_locked =='1' &&(lock_finalBillingCompleted==1 || lock_locked_counter>0)"
      >
        <i class="fa fa-lock mr-1 lg"></i>LOCKED
      </b>
      <b v-else>
        <i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED
      </b>
    </b-button>

    <b-modal
      id="Common_modal-lock-conf"
      ref="Common_modal-lock-conf"
      :title="title + lock_jb_series"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
          <div class="col-md-2 text-right">
            <label for="ColumnName">Reason :</label>
          </div>
          <div class="col-md-10 mt-2">
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="lockPanelDetail.lockReason"
              required
            ></b-form-textarea>
        </div>

        <div class="col-md-12 text-center">
          <center>
            <b-button
              v-if="lockPanelDetail.lockReason"
              :disabled="lockPanelDetail.lock_button ? true : false"
              variant="success"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              @click="CommonConfLock"
            >Send</b-button>
            <b-button
              @click="CommoncloseCommonLockUnLockConfirm"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              variant="danger"
            >Close</b-button>
          </center>
        </div>
      </div>
    </b-modal>
    <!-- Assignment Summary Modal End -->
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";

export default {
  props: [
    "title",
    "lock_assign_date",
    "lock_assign_job_type",
    "lock_assign_raised_from",
    "lock_assign_raised_by",
    "lock_all_module_id",
    "lock_jb_series",
    "lock_client_id",
    "lock_pod_id",
    "lock_shipmentType",
    "lock_transportType",
    "lock_containerInfo",
    "lock_multipleContainerType",
    "lock_clientType",

    "lock_is_misc_locked",
    "lock_ff_is_locked",
    "lock_tpt_is_locked",
    "lock_cc_is_locked",
    "lock_consoli_is_locked",
    "lock_all_locked_counter",
    "lock_all_lock_date_time",
    "lock_extra_payment_count",
    "lock_finalBillingCompleted",
    "lock_item"
  ],
  beforeMount() {
    if (this.lock_all_module_id != "" && this.Filter_Flag == true) {
      this.getServicesData();
      this.getAssignmentMultiUpdate();
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      Filter_Flag: false,

      lockPanelDetail: {
        lock_allModuleId: this.lock_all_module_id,
        shipmentType: this.lock_shipmentType,
        transportType: this.lock_transportType,
        clientType: this.lock_clientType,
        assign_job_type: this.lock_assign_job_type,
        jb_series: this.lock_jb_series,
        containerInfo: this.lock_containerInfo,
        multipleContainerType: this.lock_multipleContainerType,

        lock_ffExportFclId: "",
        lock_ffExportFclSeries: this.lock_jb_series,
        lock_Type: "",
        lockReason: "",
        lock_button: false,
        is_locked: this.lock_is_misc_locked,
        locked_counter: this.lock_all_locked_counter
      }
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function(newVal, oldVal) {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    CommonConfLock() {
      if (this.lockPanelDetail.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.lockPanelDetail.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.lockPanelDetail.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lockPanelDetail.lock_button = true;
        let payload = {
          allModuleId: this.lockPanelDetail.lock_allModuleId,
          lockReason: this.lockPanelDetail.lockReason,
          update_keyVal: this.lockPanelDetail.lock_ffExportFclId,
          assigmnmentSeries: this.lockPanelDetail.lock_ffExportFclSeries,
          Type: this.lockPanelDetail.lock_Type,
          is_locked: this.lockPanelDetail.is_locked,
          locked_counter: this.lockPanelDetail.locked_counter,
          table_name: "main_sales_execution",
          update_key: "allModuleId",
          Title: tit,
          module_type: this.lock_assign_job_type.indexOf('MISC')>=0?"MISC JOB":(this.lock_assign_job_type.indexOf('YARD')>=0?"YARD JOB":this.lock_assign_job_type+" Common Lock Module")
        };
        console.log("Common Lock = >",payload);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.CommoncloseCommonLockUnLockConfirm();
              this.$refs["addPop"].open();
              this.viewFFExportFCL("0", "0", "1", "1");
              this.lockPanelDetail.lock_button = false;
              this.isLoading = false;
            }
            (this.lockPanelDetail.lockReason = ""), this.$refs["Common_modal-lock-conf"].hide();
          })
          .catch(error => {});
      }
    },
    CommonLockUnLock(items, type) {
      // console.log("Priyanshu Singh=>", items);
      // console.log("Priyanshu Singh type=>", type);
      this.lockPanelDetail.lock_allModuleId = items.allModuleId;
      this.lockPanelDetail.lock_ffExportFclId = 0;
      this.lockPanelDetail.lock_ffExportFclSeries = items.mainSalesSeries;
      this.lockPanelDetail.lock_Type = type;
      this.lockPanelDetail.is_locked = items.is_misc_locked;
      this.lockPanelDetail.locked_counter = items.all_locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["Common_modal-lock-conf"].show();
    },
    CommoncloseCommonLockUnLockConfirm() {
      this.$refs["Common_modal-lock-conf"].hide();
    },
  }
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// commonLock.vue?8f005e44